import ProjectAnalytics from "./ProjectAnalytics";

export default ProjectAnalytics;